/* eslint-disable @typescript-eslint/no-explicit-any */
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api'
import { useState } from 'react'
import MapStaticLocation from './map-static-location'
import { useNonce } from '~/utils/nonce-provider'

export default function MapStatic({ lng, lat }: { lng: number; lat: number }) {
	const [libraries] = useState<any[]>(['places'])
	const nonce = useNonce()
	const { isLoaded } = useJsApiLoader({
		googleMapsApiKey: ENV.GOOGLE_MAPS_API_KEY ?? '',
		language: 'sv',
		libraries: libraries,
		nonce,
	})

	return (
		<>
			{typeof google !== 'undefined' && isLoaded && (
				<GoogleMap
					mapContainerClassName="map-container h-full w-full rounded-xl shadow-xs border border-border"
					zoom={14}
					center={{ lat: lat, lng: lng }}
					options={{
						streetViewControl: false,
						mapId: ENV.GOOGLE_MAPID_LIGHT,
						mapTypeControlOptions: {
							mapTypeIds: [],
						},
						fullscreenControl: false,
						clickableIcons: false,
						tilt: 0,
						zoomControlOptions: {
							position: google.maps.ControlPosition.RIGHT_TOP,
						},
					}}
				>
					<>
						<MapStaticLocation latitude={lat} longitude={lng} />
					</>
				</GoogleMap>
			)}
		</>
	)
}
